import { Form, Formik } from 'formik'

import { Button } from '@components/Button'
import { InputField } from '@components/forms/InputField'
import { SearchIcon } from '@components/Icons'
import { SelectField } from '@components/forms/SelectField'
import {
  CampaignTypeEnum,
  campaignTypeLabel,
} from '@interfaces/promotionCampaign/CampaignTypeEnum'
import {
  CampaignStatusEnum,
  campaignStatusLabel,
} from '@interfaces/promotionCampaign/CampaignStatusEnum'
import { CampaignSearchFormProps } from './interface'

const typeOptions = [
  { label: 'ทั้งหมด', value: '' },
  ...Object.values(CampaignTypeEnum).map(v => ({
    label: campaignTypeLabel[v],
    value: v,
  })),
]

const statusOptions = [
  { label: 'ทั้งหมด', value: '' },
  ...Object.values(CampaignStatusEnum).map(v => ({
    label: campaignStatusLabel[v],
    value: v,
  })),
]

export function CampaignSearchForm({
  initialValues,
  handleSubmit,
  handleResetSearch,
}: CampaignSearchFormProps) {
  return (
    <Formik initialValues={initialValues} onSubmit={handleSubmit}>
      {({ resetForm }) => (
        <Form>
          <div className='flex flex-col mt-[40px] mb-[30px]'>
            <div className='flex justify-between items-end'>
              <div className='flex items-end gap-x-[10px]'>
                <InputField
                  name='text'
                  className='w-[350px]'
                  placeholder='ค้นหาชื่อแคมเปญ'
                  autoTrim={false}
                  leftIcon={<SearchIcon className='text-primary' />}
                  inputClassName='rounded-[20px] bg-blue-2 placeholder:text-blue-3 placeholder:h-[40px]'
                />
                <SelectField
                  name='type'
                  className='w-[180px]'
                  options={typeOptions}
                  placeholder='ประเภท'
                />
                <SelectField
                  name='status'
                  className='w-[180px]'
                  options={statusOptions}
                  placeholder='สถานะ'
                />
              </div>
              <div className='flex font-mitr justify-end gap-x-[20px]'>
                <Button
                  type='button'
                  className='text-secondary underline whitespace-pre px-0'
                  onClick={() => {
                    resetForm({
                      values: {
                        text: '',
                        type: undefined,
                        status: undefined,
                      },
                    })
                    handleResetSearch()
                  }}
                >
                  ล้างค่า
                </Button>
                <Button type='submit' className='bg-secondary text-white'>
                  <span className='text-[14px]'>ค้นหา</span>
                </Button>
              </div>
            </div>
          </div>
        </Form>
      )}
    </Formik>
  )
}
